import { IContentModel } from '~/features-shared/content/interfaces/content-model'

const SubjectURITypeToContentMap = {
  communitypost: IContentModel.Post,
  idea: IContentModel.Idea,
  qnaquestion: IContentModel.Question,
  media: IContentModel.Media,
  conference: IContentModel.Conference,
  survey: IContentModel.Survey,
  wikitree: IContentModel.Wiki,
  qnaanswer: 'answer',
}

export function getNthPartOfSubjectURI(subject_uri: string, n: number) {
  return subject_uri?.split(':')?.[n]
}

export function getSubjectURIType(subject_uri: string) { // good candidate for simple unit test
  if (subject_uri.startsWith('uuid'))
    return IContentModel.Wedo
  if (getNthPartOfSubjectURI(subject_uri, 5) === 'comment') {
    if (getNthPartOfSubjectURI(subject_uri, 3) === 'community')
      return 'message'
    else return 'comment'
  }
  const typePart = getNthPartOfSubjectURI(subject_uri, 3)
  if (SubjectURITypeToContentMap[typePart])
    return SubjectURITypeToContentMap[typePart]
}
